module.exports = __webpack_public_path__ + "img/temp.af4d8e30.png";